import React, { useEffect, useState } from "react";
import axios from "axios";
import apiUrl from "../../environment/Api";
import { useNavigate, useParams } from "react-router-dom";
import "../../assets/css/Invoicemanagement.css"; // Import the scoped CSS

const Addinvoice = () => {
  const { id } = useParams();
  const [projectNames, setProjectNames] = useState([]);
  const [courseNames, setCourseNames] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [dependentOptions, setDependentOptions] = useState([]);
  const [responseDatas, setResponseDatas] = useState([]);
  const [selectvalue, setselectvalue] = useState([]);
  const [responsePayment, setResponsePayment] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [getpaid_Date, setpaid_Date] = useState("");
  const [paid_till_date, setpaid_till_date] = useState("");
  const [next_due_date, setnext_due_date] = useState("");
  const [payment_due_date, setpayment_due_date] = useState("");
  const [invoiceInputs, setInvoiceInputs] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [gst, setGst] = useState("");
  const [nettotal, setNetTotal] = useState(0);
  const [paid, setPaid] = useState("");
  const [balance, setBalance] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [dependent, setSelectedDependent] = useState("");
  const [selectedPayType, setSelectedPayType] = useState("");
  const [paid_by, setpaid_by] = useState("");
  const [notes, setnotes] = useState("");
  const [discount, setDiscount] = useState("");
  const [courseDetails, SetCourseDetails] = useState([]);
  const [paymentarray, setpaymentarray] = useState([]);
  const [responseDatased, setResponseDatased] = useState([]);
  const [selectedbranchid, setselectedbranchid] = useState("");
  const [selectedbranchname, setselectedbranchname] = useState("");
  const [generateinvoiceData, setgenerateinvoiceData] = useState([]);
  const [fromstudent, setfromstudent] = useState([]);
  const [selectedbranch, setselectedbranch] = useState({
    branch_id: "",
    branch_name: "",
    branch_from: "",
  });
  const [paymenttype, setpaymenttype] = useState([]);
  const navigate = useNavigate();

  const handleNewButtonClick = async () => {
    await handleSavePayment();
    navigate(`/Studentinvoice/${postdata.invoice_no}`);
  };

  const handleclose = async () => {
    navigate(`/invoice`);
  };

  const [postdata, setPostdata] = useState({
    invoice_no: "",
    date: "",
    type: "",
    dependent: "",
    name: "",
    email: "",
    mobile_no: "",
    fees: "",
    course_id: "",
    paid_Date: "",
    paid_till_date: "",
    payment_due_date: "",
    next_due_date: "",
    person_name: "",
    contact: "",
  });

  const handleclear = () => {
    setPostdata({
      invoice_no: "",
      date: "",
      type: "",
      dependent: "",
      name: "",
      email: "",
      mobile_no: "",
      branch_id: "",
      paid_Date: "",
      paid_till_date: "",
      payment_due_date: "",
      next_due_date: "",
      person_name: "",
      contact: "",
    });
    setTableData([]);
    setPaid("");
    setSelectedPayType("");
    setpaid_by("");
    setpaid_Date("");
    setnotes("");
    setDiscount("");
    setGst("");
    setNetTotal(0);
    setSubtotal(0);
    setBalance(0);
    setpaymentarray([]);
  };

  const [addData, setAddData] = useState({
    name: "",
  });

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(apiUrl + "/course");
        SetCourseDetails(response.data);
        setCourseNames(response.data.map((item) => item.course_name));
      } catch (error) {
        console.log(error);
      }
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchD = async () => {
      try {
        const response = await axios.get(apiUrl + "/generate_invoiceno");
        console.log("Response from server generate:", response.data.invoice_no);
        setgenerateinvoiceData(response.data.invoice_no);
        postdata.invoice_no = response.data.invoice_no;
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };
    fetchD();
  }, []);

  useEffect(() => {
    if (selectedType === "course") {
      setDependentOptions(courseNames);
      console.log("dependent ", courseDetails);
    }
  }, [selectedType, projectNames, courseNames]);

  const [selectDataEmail, setSelectDataEmail] = useState("");
  const [selectDataMobile, setSelectDataMobile] = useState("");
  const [selectDataName, setSelectDataName] = useState("");
  const [selectidName, setSelectidName] = useState("");
  const [price, setPrice] = useState(0);

  useEffect(() => {
    console.log(" the console --------------------");
    fetchDatas();
  }, []);

  const fetchDatas = async () => {
    try {
      console.log(" the console --------------------1");
      const response = await axios.get(apiUrl + "/invoice_student");
      const responsePayment = await axios.get(apiUrl + "/paymenthistroy");
      console.log("Response from server type student:", response.data);
      console.log("Response from server type responsePayment:", responsePayment.data);
      setResponseDatas(response.data);
      setResponsePayment(responsePayment.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchvalue();
  }, []);

  const fetchvalue = async () => {
    try {
      const responsevalue = await axios.get(apiUrl + "/student");
      setselectvalue(responsevalue.data[responsevalue.data.length - 1]);
      console.log("the student fetch value ", selectvalue);
    } catch (error) { }
  };

  useEffect(() => {
    fetchDatased();
    paymenttyperoute();
  }, []);

  const fetchDatased = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("Response from server brach :", response.data);
      setResponseDatased(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const paymenttyperoute = async () => {
    try {
      const response = await axios.get(apiUrl + "/paytype");
      console.log("Response from server:", response.data);
      setpaymenttype(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [brachData, selectedBranchs] = useState([]);

  const handleBranchSelection = (e) => {
    console.log(responseDatased, "responseDatased", e.target.value);
    const selectedBranch = responseDatased.find(
      (item) => item.branch_id === e.target.value.toString()
    );
    if (selectedBranch) {
      console.log("The selected branch is:", selectedBranch);
      setselectedbranch({
        branch_id: selectedBranch.branch_id,
        branch_name: selectedBranch.branch_name,
      });
    } else {
      console.log("No matching branch found.");
    }
  };

  const handleNameChange = (value, id, fixedParam) => {
    console.log("Selected ID:", id);
    console.log("Fixed Parameter:", fixedParam);
    const studentData = responseDatas.find((student) => student.id === id);
    if (studentData) {
      console.log("Matching student data:", studentData);
      setSelectDataEmail(studentData.email_lead);
      setSelectDataMobile(studentData.mobile_no_lead);
    } else {
      console.log("No matching student found");
    }
    setAddData({ ...addData, name: value });
  };

  const handleChange = (e) => {
    console.log(e.target.value, "the e target value ");
    const NameDetailes = responseDatas.filter((item) => item._id == e.target.value);
    console.log("hellooo", e.target.value);
    setSelectidName(e.target.value);
    setSelectDataName(NameDetailes[0]?.student_name_lead);
    setSelectDataEmail(NameDetailes[0]?.email_lead);
    setSelectDataMobile(NameDetailes[0]?.mobile_no_lead);
    setselectedbranch({
      branch_id: NameDetailes[0]?.branch_lead.branch_id,
      branch_name: NameDetailes[0]?.branch_lead.branch_name,
      branch_from: NameDetailes[0]?.branch_lead._id,
    });
    console.log("thisa is my console", selectedbranch);
    console.log("thisa is my console", NameDetailes[0]?.branch_lead.branch_name);
    setPostdata({
      ...postdata,
      dependent: NameDetailes[0]?.Prefered_course_lead || "",
      fees: NameDetailes[0]?.fees || 0,
      course_id: NameDetailes[0]?.course_id || 0,
    });
    console.log(NameDetailes, "NameDetailes");
    const selectedIndex = e.target.selectedIndex;
    const selectedOption = e.target.options[selectedIndex];
    const selectedValue = selectedOption.value;
    const selectedId = parseInt(selectedOption.getAttribute("data-id"));
    handleNameChange(selectedValue, selectedId);
  };

  useEffect(() => {
    getInvoice();
  }, []);

  const getInvoice = async () => {
    try {
      const response = await axios.get(apiUrl + "/generate_invoiceno");
      console.log("the response for get invoice ", response.data);
      setPostdata({
        ...postdata,
        invoice_no: parseInt(response.data[0].invoice_no) + 1,
      });
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    const getCurrentDate = () => {
      const now = new Date();
      const formattedDate = now.toISOString().substr(0, 10);
      setCurrentDate(formattedDate);
    };
    getCurrentDate();
  }, []);

  useEffect(() => {
    const PaidDate = () => {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
      setpaid_Date(formattedDate);
    };
    PaidDate();
  }, []);

  const handledateChange = (value) => {
    setpaid_Date(value);
  };

  useEffect(() => {
    const now = new Date();
    const formattedDate = now.toISOString().substr(0, 10);
    setpayment_due_date(formattedDate);
  }, []);

  const handleDateChange = (e) => {
    setpayment_due_date(e.target.value);
  };

  const handleDateChange_2 = (e) => {
    setnext_due_date(e.target.value);
  };

  useEffect(() => {
    const setNextDueDate = () => {
      const now = new Date();
      now.setMonth(now.getMonth() + 1);
      const formattedDate = now.toISOString().substr(0, 10);
      setnext_due_date(formattedDate);
    };
    setNextDueDate();
  }, []);

  const handleRowCreate = (e) => {
    e.preventDefault();
    const isRowIncomplete = tableData.some((row) => !row.qty || !row.price || !row.total);
    if (isRowIncomplete) {
      alert("Please fill all the fields in the current row before adding a new one.");
      return;
    }
    const newId = Date.now();
    console.log("the set table data", tableData);
    const updatedTableData = [
      {
        id: newId,
        branch_id: selectedbranch.branch_id,
        branch_name: selectedbranch.branch_name,
        description: postdata.dependent,
        qty: 1,
        price: postdata.fees,
        total: (1 * postdata.fees).toFixed(2),
        studyingstudent: selectidName,
        course_id: postdata.course_id,
      },
    ];
    console.log("The selectedbranch data is : ", selectedbranch);
    console.log("The postdata data is : ", postdata);
    console.log("The responsePayment data is : ", responsePayment);
    const addPayment = responsePayment
      .map((item) => {
        const filteredData = updatedTableData.filter(
          (data) => data.course_id === item.course_id && data.studyingstudent === item.studyingstudent
        );
        if (filteredData.length > 0) {
          return {
            _id: item._id,
            invoice_no: item.invoice_no,
            branch_id: item.branch_id,
            details: item.details,
            date: item.date,
            paid: item.paid,
            paytype: item.paytype,
            course_id: item.course_id,
            studyingstudent: item.studyingstudent,
            ...filteredData[0],
          };
        }
        return null;
      })
      .filter(Boolean);
    setpaymentarray(addPayment);
    const paidValue = addPayment.reduce((acc, item) => acc + Number(item.paid), 0);
    setPaid(paidValue);
    setTableData(updatedTableData);
    const SubTotalis = updatedTableData.reduce((acc, item) => acc + parseFloat(item.price), 0);
    setSubtotal(SubTotalis.toFixed(2));
    setNetTotal(SubTotalis.toFixed(2));
    setBalance(SubTotalis.toFixed(2) - paidValue);
  };

  const handleInvoiceInputChange = (index, field, value) => {
    const updatedTableData = [...tableData];
    updatedTableData[index][field] = value;
    if (field === "qty" || field === "price") {
      let qty = parseFloat(updatedTableData[index].qty) || 0;
      let price = parseFloat(updatedTableData[index].price) || 0;
      updatedTableData[index].total = (qty * price).toFixed(2);
    }
    console.log(updatedTableData, "updatedTableData---");
    setTableData(updatedTableData);
    updateTotals(updatedTableData);
  };

  const updateTotals = (updatedTableData) => {
    console.log("it is sub totall updatedTableData", updatedTableData);
    const subtotalValue = updatedTableData.reduce((acc, curr) => {
      return acc + parseFloat(curr.total);
    }, 0);
    setSubtotal(subtotalValue.toFixed(2));
    const discountAmount = (subtotalValue * discount) / 100;
    const discountedSubtotal = subtotalValue - discountAmount;
    const gstAmount = isGstEnabled ? (discountedSubtotal * gst) / 100 : 0;
    const netTotalValue = discountedSubtotal + gstAmount;
    setNetTotal(netTotalValue.toFixed(2));
    setBalance((netTotalValue - parseFloat(paid || 0)).toFixed(2));
  };

  console.log("discount before nettotal", nettotal);

  const [isGstEnabled, setIsGstEnabled] = useState(false);

  const handleGstCheckboxChange = (e) => {
    setIsGstEnabled(e.target.checked);
    if (!e.target.checked) {
      setGst("");
      const discountedSubtotal = subtotal - (subtotal * discount) / 100;
      setNetTotal(discountedSubtotal.toFixed(2));
      setBalance((discountedSubtotal - parseFloat(paid || 0)).toFixed(2));
    } else {
      handleGstChange(gst);
    }
  };

  const handleGstChange = (value) => {
    const gstValue = parseFloat(value) || "";
    setGst(gstValue);
    console.log(subtotal, "jhu777tgghh");
    const discountedSubtotal = subtotal - (subtotal * discount) / 100;
    const gstAmount = (discountedSubtotal * gstValue) / 100;
    const netTotalValue = discountedSubtotal + gstAmount;
    setNetTotal(netTotalValue.toFixed(2));
    const balanceValue = netTotalValue - parseFloat(paid || 0);
    setBalance(balanceValue.toFixed(2));
  };

  const [paidsValues, setpaidValues] = useState([]);
  const [paymentHistory, setPaymentHistory] = useState([]);

  const handleSavePayment = async () => {
    const newPayment = {
      invoice_no: generateinvoiceData,
      branch_id: responseDatased.branch_id,
      details: dependent,
      date: currentDate,
      paid_Date: getpaid_Date,
      paid: paid,
      paytype: selectedPayType,
      paid_by: setpaid_Date,
      notes: notes,
      paid_till_date: postdata.paid_till_date,
      payment_due_date: payment_due_date,
      next_due_date: next_due_date,
      person_name: postdata.person_name,
      contact: postdata.contact,
    };

    const formData = {
      branch_id: selectedbranch.branch_id,
      branch_name: selectedbranch.branch_name,
      branch_from: selectedbranch.branch_from,
      invoice_no: generateinvoiceData,
      date: currentDate,
      type: selectedType,
      dependent: postdata.dependent,
      name: selectDataName,
      studyingstudent: selectidName,
      email: selectDataEmail,
      mobile: selectDataMobile,
      subtotal: subtotal,
      gst: gst,
      discount: discount,
      nettotal: nettotal,
      paytype: selectedPayType,
      paid: paid,
      paid_Date: getpaid_Date,
      paid_by: paid_by,
      notes: notes,
      balance: balance,
      course_id: postdata.course_id,
      paid_till_date: postdata.paid_till_date,
      payment_due_date: payment_due_date,
      next_due_date: next_due_date,
      person_name: postdata.person_name,
      contact: postdata.contact,
    };
    console.log("submit data  nnnnnooow", formData);

    const finaltabledata = [...tableData];

    try {
      const response = await axios.post(apiUrl + "/invoice_details", formData);
      console.log("the response for get invoice ", response.data);

      if (response) {
        if (response.status === 200) {
          navigate(`/invoice`);
          console.log("SUBMIT TABLE DATA", tableData);
          const formdata = finaltabledata.map((item) => ({
            invoice_no: postdata.invoice_no,
            branch_id: responseDatased.branch_id,
            description: item.description,
            qty: item.qty,
            price: item.price,
            total: item.total,
            studyingstudent: selectidName,
            course_id: postdata.course_id,
          }));

          try {
            const response = await axios.post(apiUrl + "/invoice_list", formdata);
            console.log("invoice list sub,mit", response.data);

            if (response.status === 200) {
              const formDatas = {
                branch_id: formData.branch_name,
                type: formData.dependent,
                date: formData.date,
                paid_to: formData.name,
                paid_by: formData.paid_by,
                paytype: formData.paytype,
                amount: formData.paid,
              };
            }
          } catch (error) {
            console.error("Error fetching data:", error.message);
          }

          try {
            const response = await axios.post(apiUrl + "/paymenthistroy", paymentarray);
            console.log("invoice list sub,mit", response.data);
          } catch (error) {
            console.error("Error fetching data:", error.message);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }

    setPaymentHistory([...paymentHistory, newPayment]);
    setPaid("");
    setSelectedPayType("");
    setpaid_by("");
    setnotes("");
  };

  const handlePaidChange = (value) => {
    const paidValue = parseFloat(value) || "";
    setPaid(paidValue);
  };

  const [paidtilldate, setpaidtilldate] = useState(0);

  const handleaddpayment = () => {
    try {
      console.log("the balance ", balance);
      const paidValue = paymentarray.reduce((acc, item) => acc + parseFloat(item.paid) || 0, 0);
      const addPayment = {
        ...postdata,
        invoice_no: postdata.invoice_no,
        branch_id: selectedbranch.branch_id,
        details: postdata.dependent,
        date: currentDate,
        paid_Date: getpaid_Date,
        paid: paid,
        paytype: selectedPayType,
        paid_by: paid_by,
        studyingstudent: selectidName,
        course_id: postdata.course_id,
        paid_till_date: paid_till_date,
        payment_due_date: payment_due_date,
        next_due_date: next_due_date,
      };
      const netTotalNumber = parseFloat(nettotal) || 0;
      const paidValueNumber = parseFloat(paidValue) || 0;
      const paidNumber = parseFloat(paid) || 0;
      console.log("Net Total: ", netTotalNumber);
      console.log("Total Paid Value: ", paidValueNumber);
      console.log("Individual Paid: ", paidNumber);
      const newBalance = netTotalNumber - (paidValueNumber + paidNumber);
      console.log("New Balance: ", newBalance);
      if (newBalance < 0) {
        alert("The payment exceeds the available balance. Please adjust the payment amount.");
        return;
      }
      setBalance(newBalance.toFixed(2));
      setpaymentarray((previous) => {
        return [...previous, addPayment];
      });
    } catch (error) {
      console.error("Error adding payment:", error);
    }
  };

  console.log(" the array payment ", paymentarray);

  useEffect(() => {
    const totalAmountValue = paymentarray.reduce((total, item) => {
      return total + Number(item.paid);
    }, 0);
    setPostdata({ ...postdata, paid_till_date: totalAmountValue });
  }, [paymentarray]);

  const formatDatefitching = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0];
  };

  const handleDelete = (index) => {
    const updatedTableData = [...tableData];
    updatedTableData.splice(index, 1);
    setTableData(updatedTableData);
    const subtotal = updatedTableData.reduce((acc, curr) => {
      return acc + (parseFloat(curr.total) || 0);
    }, 0);
    setSubtotal(subtotal.toFixed(2));
    const gstAmount = (subtotal * gst) / 100;
    const netTotal = subtotal + gstAmount;
    setNetTotal(netTotal);
    const paidValue = paymentarray.reduce((acc, item) => {
      return acc + item.paid;
    }, 0);
    const balanceValue = netTotal - paid;
    setBalance(balanceValue.toFixed(2));
  };

  const handleDiscountChange = (value) => {
    const discountPercentage = Math.max(0, parseFloat(value)) || 0;
    setDiscount(discountPercentage);
    const discountAmount = (subtotal * discountPercentage) / 100;
    const discountedSubtotal = subtotal - discountAmount;
    const gstAmount = isGstEnabled ? (discountedSubtotal * gst) / 100 : 0;
    const netTotalValue = discountedSubtotal + gstAmount;
    setNetTotal(netTotalValue.toFixed(2));
    const paidValue = parseFloat(paid) || 0;
    const balanceValue = netTotalValue - paidValue;
    setBalance(balanceValue.toFixed(2));
  };

  console.log("final net total", nettotal);

  const [paymentdelete, setPaymentDelete] = useState(false);

  async function handleDeletepayment(id, index) {
    console.log("this is payment delete", id, index);
    if (id === undefined) {
      console.error("ID is undefined");
      if (index >= 0 && index < paymentarray.length) {
        paymentarray.splice(index, 1);
        setpaymentarray([...paymentarray]);
        const paiddelete = paymentarray.reduce((acc, payment) => acc + parseFloat(payment.paid), 0);
        setPaid(paiddelete);
        setBalance(parseFloat(nettotal) - paiddelete);
      }
      return;
    }
    if (index < 0 || index >= paymentarray.length) {
      console.error("Index is out of bounds");
      return;
    }
    try {
      const response = await axios.delete(`${apiUrl}/paymenthistroy/${id}`);
      console.log("Payment deleted successfully", response.data);
      paymentarray.splice(index, 1);
      setpaymentarray([...paymentarray]);
      const paiddelete = paymentarray.reduce((acc, payment) => acc + parseFloat(payment.paid || 0), 0);
      console.log("Payment deleted amount:", paiddelete, "Net Total:", nettotal, "Paid Total:", paiddelete);
      setPaid(paiddelete);
      setBalance(parseFloat(nettotal) - paiddelete);
      setPaymentDelete(true);
    } catch (error) {
      console.error("Error deleting payment", error);
    }
  }

  useEffect(() => {
    if (paymentdelete) {
      handleSavePayment();
    }
  }, [paymentdelete]);

  useEffect(() => {
    handleChange_2();
  }, []);

  const { roll_no } = useParams();

  useEffect(() => {
    if (roll_no) {
      const getstudent_id = async () => {
        try {
          const stu_data = await axios.get(`${apiUrl}/studentpaid/${roll_no}`);
          addData.name = stu_data.data[0]._id;
          handleChange_2(stu_data.data[0]._id);
        } catch (error) {
          console.log("there was the error in the getstudent_id is : ", error);
        }
      };
      getstudent_id();
    }
  }, [roll_no]);

  const handleChange_2 = async (_id) => {
    const response = await axios.get(apiUrl + "/student");
    setResponseDatas(response.data);
    console.log(response, "the data was ");
    let NameDetails;
    if (Array.isArray(response.data) && _id) {
      NameDetails = response?.data?.find((item) => item?._id === _id);
    } else {
      NameDetails = response?.data || {};
    }
    console.log(NameDetails, "student_name_lead");
    if (NameDetails) {
      setSelectidName(_id);
      setSelectDataName(NameDetails?.student_name_lead || "");
      setSelectDataEmail(NameDetails?.email_lead || "");
      setSelectDataMobile(NameDetails?.mobile_no_lead || "");
      console.log(NameDetails?.student_name_lead, "student_name_lead");
      console.log(NameDetails?.email_lead, "email_lead");
      const branchLead = NameDetails?.branch_lead || {};
      setselectedbranch({
        branch_id: branchLead?.branch_id || "",
        branch_name: branchLead?.branch_name || "",
        branch_from: branchLead?._id || "",
      });
      setPostdata({
        ...postdata,
        dependent: NameDetails?.Prefered_course_lead || "",
        fees: NameDetails?.fees || 0,
        course_id: NameDetails?.course_id || 0,
      });
    }
  };

  return (
    <div className="invoice-management-wrapper">
      {/* Header */}
      <div className="invoice-header">
        <h5>Add Invoice</h5>
      </div>

      {/* Row 1: Invoice No and Date */}
      <div className="invoice-card">
        <div className="invoice-row">
          {generateinvoiceData && (
            <div style={{ flex: "0 0 140px" }}>
              <label>Invoice No</label>
              <input
                type="text"
                value={generateinvoiceData}
                onChange={(e) => setPostdata({ ...postdata, invoice_no: e.target.value })}
              />
            </div>
          )}
          {/* <div></div> */}
          <div style={{ flex: "0 0 140px" }}>
            <label>Date</label>
            <input type="date" value={currentDate} readOnly />
          </div>


          {/* Row 2: Name, Email, Mobile */}
          {/* <div className="invoice-card">
            <div className="invoice-row"> */}
          <div>
            <label>Student Name</label>
            {id ? (
              <select value={addData.name || ""} onChange={(e) => handleChange_2(e.target.value)}>
                <option value="">Select Name</option>
                {Array.isArray(responseDatas) &&
                  responseDatas.map((item, index) => (
                    <option key={index} value={item._id}>
                      {item.roll_no} - {item.student_name_lead}
                    </option>
                  ))}
              </select>
            ) : (
              <select value={addData.name || ""} onChange={handleChange}>
                <option value="">Select Name</option>
                {Array.isArray(responseDatas) &&
                  responseDatas.map((item, index) => (
                    <option key={index} value={item._id}>
                      {item.roll_no} - {item.student_name_lead}
                    </option>
                  ))}
              </select>
            )}
          </div>
          <div>
            <label>Email</label>
            <input type="text" value={selectDataEmail} disabled />
          </div>
          <div style={{ flex: "0 0 140px" }}>
            <label>Mobile</label>
            <input type="tel" value={selectDataMobile} disabled />
          </div>
        </div>
      </div>
      {/* </div>
      </div> */}

      {/* Row 3: Course, Branch, Type, Add Button */}
      <div className="invoice-card">
        <div className="invoice-row">
          <div>
            <label>Course</label>
            <input type="text" value={postdata.dependent} disabled />
          </div>
          <div>
            <label>Branch</label>
            <select value={selectedbranch.branch_id} onChange={(e) => handleBranchSelection(e)}>
              {responseDatased.map((item, index) => (
                <option key={index} value={item.branch_id}>
                  {`${item.branch_id}-${item.branch_name}`}
                </option>
              ))}
            </select>
          </div>
          <div style={{ flex: "0 0 100px" }}>
            <label>Type</label>
            <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
              <option value="">Select Type</option>
              <option value="course">Course</option>
            </select>
          </div>


          {/* Row 4: Paid Till, Next Due, Person, Contact */}
          {/* <div className="invoice-card">
            <div className="invoice-row"> */}
              <div style={{ flex: "0 0 140px" }}>
                <label>Paid Till</label>
                <input
                  type="text"
                  value={postdata.paid_till_date}
                  onChange={(e) => setPostdata({ ...postdata, paid_till_date: e.target.value })}
                />
              </div>
              <div style={{ flex: "0 0 140px" }}>
                <label>Next Due</label>
                <input type="date" value={next_due_date} onChange={handleDateChange_2} />
              </div>
              <div>
                <label>Person</label>
                <input
                  type="text"
                  value={postdata.person_name}
                  onChange={(e) => setPostdata({ ...postdata, person_name: e.target.value })}
                />
              </div>
              <div style={{ flex: "0 0 140px" }}>
                <label>Contact</label>
                <input
                  type="text"
                  value={postdata.contact}
                  onChange={(e) => setPostdata({ ...postdata, contact: e.target.value })}
                />
              </div>
            {/* </div>
          </div> */}
          <div style={{ flex: "0 0 120px" }}>
            <button type="button" className="btn-secondary" onClick={handleRowCreate} style={{ width: "100%" }}>
              Add
            </button>
          </div>
        </div>
      </div>
      {/* Invoice Items and Calculation Panel */}
      <div className="invoice-items-container">
        {/* Left Side: Invoice Items + Payment History */}
        <div className="left-tables-wrapper">
          {/* Invoice Items Table */}
          <div className="invoice-items-table">
            <h5>Invoice Items</h5>
            <div className="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "35px" }}>S.No</th>
                    <th>Description</th>
                    <th style={{ width: "80px" }}>Qty</th>
                    <th style={{ width: "100px" }}>Fees</th>
                    <th style={{ width: "100px" }}>Total</th>
                    <th style={{ width: "50px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((data, index) => (
                    <tr key={data.id}>
                      <td>{index + 1}</td>
                      <td>
                        <input type="text" value={data.description} />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={tableData[index]?.qty || ""}
                          onChange={(e) => handleInvoiceInputChange(index, "qty", e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={tableData[index]?.price || ""}
                          onChange={(e) => handleInvoiceInputChange(index, "price", e.target.value)}
                        />
                      </td>
                      <td>
                        <input type="text" value={tableData[index]?.total || ""} readOnly />
                      </td>
                      <td>
                        <i
                          className="fa-sharp-duotone fa-solid fa-circle-xmark delete-icon"
                          onClick={() => handleDelete(index)}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Payment History Table */}
          <div className="payment-history-table">
            <h5>Payment History</h5>
            <div className="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "35px" }}>No</th>
                    <th style={{ width: "80px" }}>Branch</th>
                    <th>Details</th>
                    <th style={{ width: "90px" }}>Date</th>
                    <th style={{ width: "70px" }}>Paid</th>
                    <th style={{ width: "70px" }}>Type</th>
                    <th style={{ width: "70px" }}>By</th>
                    <th style={{ width: "50px" }}>Del</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentarray.map((payment, index) => (
                    <tr key={payment.id || index}>
                      <td>{index + 1}</td>
                      <td>{payment.branch_id}</td>
                      <td>{payment.details}</td>
                      <td>{formatDatefitching(payment.date)}</td>
                      <td>₹{payment.paid}</td>
                      <td>{payment.paytype}</td>
                      <td>{payment.paid_by}</td>
                      <td>
                        <i
                          className="fa-solid fa-xmark delete-icon"
                          onClick={() => handleDeletepayment(payment._id, index)}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Calculation Panel - Right Side */}
        <div className="calculation-panel">
          <div className="calc-row">
            <span className="calc-label">Subtotal</span>
            <input type="number" className="calc-input" value={subtotal} readOnly />
          </div>

          <div className="calc-row">
            <span className="calc-label">
              GST
              <input type="checkbox" onChange={handleGstCheckboxChange} />
            </span>
            <input
              type="number"
              className="calc-input"
              value={gst}
              onChange={(e) => handleGstChange(Math.max(0, e.target.value))}
              disabled={!isGstEnabled}
              placeholder="0%"
            />
          </div>

          <div className="calc-row">
            <span className="calc-label">Discount (%)</span>
            <input
              type="number"
              className="calc-input"
              value={discount}
              onChange={(e) => handleDiscountChange(Math.max(0, e.target.value))}
              placeholder="0%"
            />
          </div>

          <div className="calc-row">
            <span className="calc-label">Net Total</span>
            <input type="number" className="calc-input" value={nettotal} readOnly />
          </div>

          <div className="calc-row">
            <span className="calc-label">Pay Type</span>
            <select className="calc-input" value={selectedPayType} onChange={(e) => setSelectedPayType(e.target.value)}>
              <option value="">Select</option>
              {paymenttype.map((item, index) => (
                <option key={index} value={item.Payment_type}>
                  {item.Payment_type}
                </option>
              ))}
            </select>
          </div>

          <div className="calc-row">
            <span className="calc-label">Paid By</span>
            <select className="calc-input" value={paid_by} onChange={(e) => setpaid_by(e.target.value)}>
              <option value="">Select</option>
              <option value="Parent">Parent</option>
              <option value="Student">Student</option>
              <option value="Gradian">Guardian</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="calc-row">
            <span className="calc-label">Paid Amt</span>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem", width: "140px" }}>
              <input
                type="number"
                value={paid}
                disabled={selectedPayType === ""}
                onChange={(e) => handlePaidChange(e.target.value)}
                placeholder="0.00"
              />
              <button
                className="btn-primary"
                onClick={handleaddpayment}
                disabled={!paid || !selectedPayType}
                style={{ fontSize: "0.7rem", padding: "0.3rem" }}
              >
                Add
              </button>
            </div>
          </div>

          <div className="calc-row">
            <span className="calc-label">Paid Date</span>
            <input
              type="date"
              className="calc-input"
              value={getpaid_Date}
              onChange={(e) => handledateChange(e.target.value)}
            />
          </div>

          <div className="calc-row">
            <span className="calc-label">Balance</span>
            <input type="number" className="calc-input" value={balance} readOnly />
          </div>

          {/* Action Buttons */}
          <div className="button-group">
            <button type="button" className="btn-danger" onClick={handleclose}>
              Close
            </button>
            <button type="button" className="btn-info" onClick={handleclear}>
              Clear
            </button>
            <button type="button" className="btn-secondary" onClick={handleSavePayment}>
              Save
            </button>
            <button type="button" className="btn-success" onClick={handleNewButtonClick}>
              Print
            </button>
            <button type="button" className="btn-success" onClick={() => navigate("/invoice_email")}>
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addinvoice;